module.exports = __webpack_public_path__ + "static/media/shortboard.0087fd4f.jpg";